import { useThemeStore } from '../stores/themeStore';
import { useTranslation } from 'react-i18next';
import { Sun, Moon } from 'lucide-react';

export default function Header() {
  const { isDark, toggleTheme } = useThemeStore();
  const { t } = useTranslation();

  return (
    <header
      className="fixed top-0 w-full z-50 text-white overflow-hidden border-b border-white/10 -mb-px"
      style={{
        backgroundImage: "url(/hero-bg.jpeg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backdropFilter: "blur(6px)",
          zIndex: 0,
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(to bottom right, rgba(15, 23, 42, 0.9), rgba(30, 58, 138, 0.85), rgba(15, 23, 42, 0.9))",
          zIndex: 1,
        }}
      ></div>
      <div className="container mx-auto max-w-7xl px-4 h-16 relative z-20">
        <div className="flex items-center justify-between h-full">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img
              src="/logo_only.png"
              alt="Aitomata"
              className="h-10 w-10 object-contain"
            />
            <span className="text-lg font-bold text-white" style={{ fontFamily: "Drupadi" }}>
              Aitomata
            </span>
          </div>

          {/* Title - Desktop only - Absolutely centered */}
          <h1 className="hidden md:block absolute left-1/2 -translate-x-1/2 font-display text-lg font-bold text-white">
            {t('checkout.title')}
          </h1>

          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            className="p-2 rounded-lg border border-white/30 bg-white/10 hover:bg-white/20 transition-colors"
            aria-label="Toggle theme"
          >
            {isDark ? (
              <Sun className="h-5 w-5 text-white" />
            ) : (
              <Moon className="h-5 w-5 text-white" />
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
